import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['accpentanceAddress'];

const fetchaAcpentance = async () => {
  const res = await request.get(
    `/FlatsGrid/acceptance_statuses_address_life_cycle`,
    null,
    'Не удалось загрузить статусы приемки'
  );
  return res;
};

const useAcpentanceQuery = (options) => {
  const query = useQuery(key(), fetchaAcpentance, options);
  return {
    data: query.data,
    loading: query.isLoading
  }
}


export { useAcpentanceQuery };